import axios from 'axios'
import u from '@/utils'

const state = {
  rulesLoading: false,
  rules: [],
  ruleProfiles: {},
  ruleHistory: [],
  totalRules: 0
}

const mutations = {
  setRulesLoading(state, isLoading) {
    state.rulesLoading = isLoading
  },

  setRules(state, rules) {
    state.rules = rules
  },
  setRuleHistory(state, ruleHistory) {
    state.ruleHistory = ruleHistory
  },
  setTotalRules(state, totalCount) {
    state.totalRules = totalCount
  },
  setRuleProfiles(state, payload) {
    state.ruleProfiles = {
      ...state.ruleProfiles,
      [payload.rule.hexId]: payload.profiles
    }
  },

  updateRule(state, rule) {
    let index = state.rules.findIndex(item => item.hexId === rule.hexId)
    state.rules.splice(index, 1, rule)
  }
}

let actions = {
  async fetchRules({ commit }) {
    commit('setRulesLoading', true)
    let response = await axios.get('/api/v1/rules')
    let rules = [...response.data._embedded.rules]
    rules = rules.map(rule => u.processResp(rule))
    commit('setRules', rules)
    commit('setRulesLoading', false)
    return rules
  },

  async fetchRuleHistory({ commit }, urlParams) {
    let url = '/api/core/audit/revisions/rule?'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + urlParams
    }
    let response = await axios.get(url)
    if (response.data) {
      let ruleHistory = [...response.data.content]
      commit('setRuleHistory', ruleHistory)
      commit('setTotalRules', response.data.totalElements)
      return ruleHistory
    }
  },

  async fetchRuleProfiles({ commit }, rule) {
    let response = await axios.get(`/api/v1/rules/${rule.hexId}/profiles`)
    let profiles = [...response.data._embedded.profiles]
    profiles = profiles.map(profile => u.processResp(profile))
    commit('setRuleProfiles', { rule, profiles })
    return profiles
  },

  async updateRule({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/rules/${hexId}`, body)
    let rule = u.processResp(response.data)
    let res = await axios.get(`/api/v1/rules/${hexId}/diagram`)
    rule.data = res.data
    commit('updateRule', response.data)
    return rule
  },

  async addProfilesToRule(context, payload) {
    let data = payload.profileIds
      .map(profileId => {
        return `/api/v1/profiles/${profileId}`
      })
      .join('\n')
    let response = await axios.put(
      `/api/v1/rules/${payload.rule.hexId}/profiles`,
      data,
      {
        headers: {
          'Content-Type': 'text/uri-list'
        }
      }
    )
    return response.data
  },

  async fetchRule({ commit }, hexId) {
    let response = await axios.get(`/api/v1/rules/${hexId}`)
    let rule = u.processResp(response.data)
    let res = await axios.get(`/api/v1/rules/${hexId}/diagram`)
    rule.data = res.data
    commit('updateRule', rule)
    return rule
  },

  async fetchDefaultRule() {
    let response = await axios.get('/dmn/newDiagram.dmn', {
      responseType: 'text'
    })
    return response.data
  },

  async deleteRule(context, hexId) {
    await axios.delete(`/api/v1/rules/${hexId}`)
  },

  async saveRule(context, ruleBody) {
    let response = await axios.post('/api/v1/rules', ruleBody)
    let rule = u.processResp(response.data)
    let res = await axios.get(`/api/v1/rules/${rule.hexId}/diagram`)
    rule.data = res.data
    return rule
  },

  async deployRule(context, hexId) {
    let response = await axios.post(`/api/v1/rules/${hexId}/deploy`)
    return response.data
  }
}

export default {
  state,
  actions,
  mutations
}
